export default __webpack_public_path__ + "static/media/move-material-4.c5bbc0a2.webp";